import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';
import _ from 'lodash';

export default function engagementHelixProjectSummaryReducer(state = initialState.engagementHelixProjectSummary, action) {
    switch (action.type) {
        case actions.GET_ENGAGEMENT_HELIX_SUMMARY: {
            if (!action.error) {
                return action.response;
            }
            return state;
        }
        default:
            return state;
    }
}
